/* ShivaRam — Página «Mis favoritos». Solo carga los productos guardados. */
(function () {
  var KEY = 'sr_wishlist_v1';
  var TEXTS = {
    es: { count1: '1 producto guardado', countN: '{n} productos guardados', add: 'Añadir al carrito', adding: 'Añadiendo…', added: 'Añadido · Ver carrito', choose: 'Elegir opciones', view: 'Ver producto', soldout: 'Agotado', remove: 'Quitar {t} de favoritos', removed: 'Eliminado de favoritos', error: 'No se ha podido añadir. Inténtalo de nuevo.', addedToast: 'Añadido al carrito', loading: 'Cargando tus favoritos…' },
    en: { count1: '1 saved product', countN: '{n} saved products', add: 'Add to cart', adding: 'Adding…', added: 'Added · View cart', choose: 'Choose options', view: 'View product', soldout: 'Sold out', remove: 'Remove {t} from favourites', removed: 'Removed from favourites', error: 'Couldn’t add it. Please try again.', addedToast: 'Added to cart', loading: 'Loading your favourites…' },
    fr: { count1: '1 produit enregistré', countN: '{n} produits enregistrés', add: 'Ajouter au panier', adding: 'Ajout…', added: 'Ajouté · Voir le panier', choose: 'Choisir les options', view: 'Voir le produit', soldout: 'Épuisé', remove: 'Retirer {t} des favoris', removed: 'Retiré des favoris', error: 'Impossible d’ajouter. Réessayez.', addedToast: 'Ajouté au panier', loading: 'Chargement de vos favoris…' },
    de: { count1: '1 gespeichertes Produkt', countN: '{n} gespeicherte Produkte', add: 'In den Warenkorb', adding: 'Wird hinzugefügt…', added: 'Hinzugefügt · Warenkorb', choose: 'Optionen wählen', view: 'Produkt ansehen', soldout: 'Ausverkauft', remove: '{t} aus Favoriten entfernen', removed: 'Aus Favoriten entfernt', error: 'Konnte nicht hinzugefügt werden. Bitte erneut versuchen.', addedToast: 'In den Warenkorb gelegt', loading: 'Favoriten werden geladen…' }
  };
  var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  var t = TEXTS[lang] || TEXTS.es;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function read() {
    if (window.SRWishlist) return window.SRWishlist.read();
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function removeId(id) {
    if (window.SRWishlist) { window.SRWishlist.remove(id); return; }
    try {
      var list = read().filter(function (i) { return String(i.id) !== String(id); });
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = el('div', 'sr-wl-toast');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3000);
  }

  function fetchProduct(item) {
    if (!item.handle) return Promise.resolve(null);
    return fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function fetchAll(items) {
    var out = new Array(items.length), i = 0;
    function worker() {
      if (i >= items.length) return Promise.resolve();
      var idx = i++;
      return fetchProduct(items[idx]).then(function (p) { out[idx] = p; return worker(); });
    }
    var workers = [];
    for (var k = 0; k < Math.min(6, items.length); k++) workers.push(worker());
    return Promise.all(workers).then(function () { return out; });
  }

  function addToCart(variantId, btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = t.adding;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root + 'cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'sr-favoritos', data: { source: 'sr-favoritos', itemCount: cart.item_count } } }));
        } catch (e) {}
        var a = el('a', 'sr-fav__btn sr-fav__btn--ghost', t.added);
        a.href = root + 'cart';
        btn.replaceWith(a);
        toast(t.addedToast);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        toast(t.error);
      });
  }

  function init(rootEl) {
    var grid = rootEl.querySelector('[data-sr-fav-grid]');
    var countEl = rootEl.querySelector('[data-sr-fav-count]');
    var emptyEl = rootEl.querySelector('[data-sr-fav-empty]');
    var fullEl = rootEl.querySelector('[data-sr-fav-full]');
    var loadingEl = rootEl.querySelector('[data-sr-fav-loading]');

    function setCount(n) {
      if (countEl) countEl.textContent = n === 1 ? t.count1 : t.countN.replace('{n}', n);
      if (n === 0) { fullEl.hidden = true; emptyEl.hidden = false; }
    }

    var items = read();
    if (loadingEl) loadingEl.textContent = t.loading;
    if (!items.length) { if (loadingEl) loadingEl.hidden = true; setCount(0); return; }

    fetchAll(items).then(function (products) {
      if (loadingEl) loadingEl.hidden = true;
      var shown = 0;
      products.forEach(function (p, idx) {
        if (!p) { removeId(items[idx].id); return; }
        shown++;
        var card = el('li', 'sr-fav__card');
        card.setAttribute('data-id', String(p.id));

        var media = el('a', 'sr-fav__media');
        media.href = p.url || (root + 'products/' + p.handle);
        media.setAttribute('tabindex', '-1');
        media.setAttribute('aria-hidden', 'true');
        if (p.featured_image) {
          var im = document.createElement('img');
          im.src = img(p.featured_image, 500);
          im.srcset = img(p.featured_image, 300) + ' 300w, ' + img(p.featured_image, 500) + ' 500w, ' + img(p.featured_image, 700) + ' 700w';
          im.sizes = '(min-width: 990px) 22vw, (min-width: 750px) 30vw, 46vw';
          im.alt = '';
          im.loading = 'lazy';
          media.appendChild(im);
        } else {
          media.appendChild(el('span', 'sr-fav__ph', (p.title || '?').charAt(0)));
        }

        var rm = el('button', 'sr-fav__remove');
        rm.type = 'button';
        rm.setAttribute('aria-label', t.remove.replace('{t}', p.title));
        rm.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        rm.addEventListener('click', function () {
          removeId(p.id);
          card.remove();
          shown--;
          setCount(shown);
          toast(t.removed);
        });

        var mediaWrap = el('div', 'sr-fav__media-wrap');
        mediaWrap.appendChild(media);
        mediaWrap.appendChild(rm);

        var name = el('a', 'sr-fav__name', p.title);
        name.href = media.href;

        var price = el('p', 'sr-fav__price', p.available ? money(p.price) : t.soldout);

        var action;
        var variants = p.variants || [];
        if (!p.available) {
          action = el('a', 'sr-fav__btn sr-fav__btn--ghost', t.view);
          action.href = media.href;
        } else if (variants.length === 1) {
          action = el('button', 'sr-fav__btn', t.add);
          action.type = 'button';
          action.addEventListener('click', function () { addToCart(variants[0].id, action); });
        } else {
          action = el('a', 'sr-fav__btn sr-fav__btn--ghost', t.choose);
          action.href = media.href;
        }

        card.appendChild(mediaWrap);
        card.appendChild(name);
        card.appendChild(price);
        card.appendChild(action);
        grid.appendChild(card);
      });
      if (shown > 0) { fullEl.hidden = false; emptyEl.hidden = true; }
      setCount(shown);
    });
  }

  function start() {
    var nodes = document.querySelectorAll('[data-sr-fav]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-ready')) continue;
      nodes[i].setAttribute('data-ready', '1');
      init(nodes[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
